import "./About.scss";
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

import {urlFor, client} from '../../client'

import {AppWrap, MotionWrap} from '../../wrapper'

const About = () => {

  const [abouts, setAbouts] = useState([])

  useEffect(() => {
    const query = '*[_type == "abouts"]'
    client.fetch(query)
    .then((data) =>setAbouts(data))
  }, [])


  return (
    <div className="about-bg">
      <h1 className="about-header-h1" data-scroll data-scroll-direction="horizontal" data-scroll-speed="-5">Technologies I use.</h1>
      <h1 className="about-header-h1" data-scroll data-scroll-direction="horizontal" data-scroll-speed="5">Technologies I use.</h1>
      <h1 className="about-header-h1" data-scroll data-scroll-direction="horizontal" data-scroll-speed="-5">Technologies I use.</h1>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div key={about.title + index} className="app__profile-item" whileInView={{opacity: 1}} whileHover={{scale: 1.1}} transition={{duration: 0.5, type: 'tween'}}>
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{marginTop: 20}}>{about.title}</h2>
            <p className="p-text" style={{marginTop: 10}}>{about.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default AppWrap(MotionWrap(About, 'app__about'), 'about', "app__whitebg");
